import Component from './General';

export default Component;
